import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { redefinirSenhaPorToken } from "../../api/admin";
import { usePageSeo } from "../../seo/usePageSeo";
import "./RedefinirSenha.scss";

export default function RedefinirSenha() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";

  usePageSeo({
    title: "Redefinir senha — AgendaUni",
    description: "Defina uma nova senha de acesso à AgendaUni.",
    path: "/redefinir-senha",
    noindex: true,
  });
  const [novaSenha, setNovaSenha] = useState("");
  const [confirma, setConfirma] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) {
      Swal.fire("Erro", "Link inválido — token ausente.", "error");
      return;
    }
    if (novaSenha.length < 6) {
      Swal.fire(
        "Atenção",
        "Senha precisa ter ao menos 6 caracteres.",
        "warning",
      );
      return;
    }
    if (novaSenha !== confirma) {
      Swal.fire("Atenção", "As senhas não coincidem.", "warning");
      return;
    }
    setLoading(true);
    try {
      await redefinirSenhaPorToken(token, novaSenha);
      await Swal.fire(
        "Tudo certo!",
        "Senha redefinida. Faça login com a nova senha.",
        "success",
      );
      navigate("/", { replace: true });
    } catch (err) {
      Swal.fire("Erro", err?.message || "Token inválido ou expirado.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="redefinir-senha">
      <form onSubmit={submit}>
        <h1>Redefinir senha</h1>
        <p className="dica">Defina uma nova senha. Mínimo de 6 caracteres.</p>
        <label>
          Nova senha
          <input
            type="password"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            autoComplete="new-password"
            required
          />
        </label>
        <label>
          Confirmar senha
          <input
            type="password"
            value={confirma}
            onChange={(e) => setConfirma(e.target.value)}
            autoComplete="new-password"
            required
          />
        </label>
        <button type="submit" disabled={loading}>
          {loading ? "Salvando..." : "Salvar nova senha"}
        </button>
        <Link to="/" className="voltar">
          Voltar ao login
        </Link>
      </form>
    </div>
  );
}
